<nz-layout class="app-layout" [ngClass]="{ 'ant-layout-custom' : true }">
    <nz-header class="text-center" style="background: none;" >
        <!-- <div nz-col nzXs="0" nzSm="0" nzMd="0" nzLg="8" nzXL="8" style="text-align:center;">
            <img src="./../assets/Images/theme_logo/{{themeService.themeLogo()}}" class="header-logo" />
        </div> -->
        <h3>WHATSAPP BUSINESS SIGNUP</h3>
    </nz-header>
    <nz-content >
        <div nz-row nzJustify="center">
            <div nz-col nzSpan="12">

                This will link your WhatsApp Business profile to the StockFinder App for use within StockFinder, enabling sending of WhatsApp messages from StockFinder for quotes etc. There will also be functionality for receiving messages inside StockFinder, automatically assigning to the correct Fitment Centre, Salesman and Customer profile. <br /> <br />
                
            </div>
        </div>
        <div nz-row nzJustify="center" >
            <div nz-col nzSpan="12">
                <form [formGroup]="waSignupForm">
                    <nz-form-item>
                        <nz-form-label [nzSpan]="6">Whatsapp Account Name</nz-form-label>
                        <nz-form-control [nzSpan]="14">
                            <input nz-input formControlName="whatsappAccountName" placeholder="Whatsapp Account Name" />
                            
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label [nzSpan]="6">Whatsapp Phone Number</nz-form-label>
                        <nz-form-control [nzSpan]="14">
                            <nz-input-group nzAddOnBefore="+27" >
                                <input nz-input formControlName="whatsappCellNumber" placeholder="821234567" />
                            
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>
                    <button nz-button nzType="primary" (click)="triggerFbLogin()" style="text-align: center; align-self: center;">LINK WHATSAPP BUSINESS ACCOUNT</button>
                </form>
            </div>
        </div>
        
    </nz-content>
</nz-layout>